import { getActionGroup } from '@ziynx/components/utilities';
import ActionTypes from '@ziynx/action-types';

type AdminActions = {
  type: string,
}

const initialState = {
  results: [],
  page: 0,
  pageSize: 25,
  isLastPage: false,
  fetching: false,
};

export default function reduceAdminTalentScorecards(state = initialState, action: AdminActions) {
  if (!action.type) {
    return state;
  }

  const actionGroup = getActionGroup(action?.type);

  switch (action.type) {
  case ActionTypes.admin.getAllScorecards.START:
    return {
      ...state,
      fetching: true,
      ...(action?.response || {}),
    };

  case ActionTypes.admin.getAllScorecards.SUCCESS:
    return {
      ...state,
      fetching: false,
      ...(action?.response || {}),
      results: action?.response?.page > 0
        ? (state?.results ?? []).concat(action?.response?.results ?? [])
        : action?.response?.results,
    };

  case ActionTypes.admin.getAllScorecards.ERROR:
    return {
      ...state,
      fetching: false,
      ...(action?.response || {}),
    };

  case ActionTypes.admin.talentFilters.START:
    return {
      ...state,
      [actionGroup]: {
        fetching: true,
        success: false,
        error: null,
      },
    };

  case ActionTypes.admin.talentFilters.SUCCESS:
    return {
      ...state,
      ...action?.response ?? {},
      filters: action?.response?.filters,
      addedFilters: true,
      [actionGroup]: {
        fetching: false,
        success: true,
        error: null,
      },
    };

  case ActionTypes.admin.talentFilters.ERROR:
    return {
      ...state,
      [actionGroup]: {
        fetching: false,
        success: false,
        error: action?.error,
      },
    };

  case ActionTypes.admin.clearTalentFilters:
    return {
      ...state,
      ADMIN_TALENT_FILTERS_API: {},
    };

  default:
    return state;
  }
}
